import { render } from "./BaseButton.vue?vue&type=template&id=dd72f982&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=dd72f982&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd72f982"

export default script